import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=6fc0b0f2&"
import script from "./checkDialog.vue?vue&type=script&lang=js&"
export * from "./checkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports